import { createSelector } from '@reduxjs/toolkit';

import type { SidebarState } from './types';
import { ReduxState } from 'app/redux/types';

import { BREAKPOINTS_PROPS } from 'app/constants/ReduxResponsive';

import { SidebarWidth, Tab } from './constants';

// ---

export const selectSidebarState = (state: ReduxState): SidebarState => {
  return state.sidebar;
};

export const selectActiveTab = (state: ReduxState): Tab => {
  return selectSidebarState(state).activeTab;
};

export const selectToAllowRefreshWarning = (state: ReduxState): boolean => {
  return selectSidebarState(state).allowRefreshWarning;
};

// ---

export const selectIsWideScreen = (state: ReduxState): boolean => (
  state.browser && state.browser.greaterThan.medium
);

const selectSidebarInitialWidth = (state: ReduxState): SidebarWidth => (
  selectIsWideScreen(state) ? SidebarWidth.MAX : SidebarWidth.MIN
);

export const selectSidebarWidth = createSelector(
  selectSidebarInitialWidth,
  (state: ReduxState) => (
    state.browser
      ? BREAKPOINTS_PROPS[state.browser.mediaType as keyof typeof BREAKPOINTS_PROPS]
      : false
  ),
  (initWidth, breakpoint) => {
    if (!(breakpoint && breakpoint.sidebarResizeStep)) {
      return initWidth;
    }

    return initWidth + breakpoint.sidebarResizeStep;
  },
);
